import { useCheckoutMessage } from '@/scopes/checkout/domain/hooks'
import { bannerColorMap, BannerType } from '@/scopes/checkout/domain/types'
import { Banner, type BannerColors } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'

export function CheckoutMessage(props: { componentId: string }) {
  const { componentId } = props
  const { message } = useCheckoutMessage(componentId)

  if (!message)
    return null

  const { banners } = message
  if (!banners.length) {
    return null
  }

  return (
    <>
      {banners.map(
        ({ title, text, type = 'info' }: { title?: string, text?: string, type?: string }, index: number) => (
          <Banner
            key={`banner-${index}`}
            color={bannerColorMap[type as BannerType] as BannerColors}
            text={title ?? ''}
            size={'M' as any}
            supportingText={text}
            hasIcon={true as any}
          />
        ),
      )}
    </>
  )
}
